import { Fragment } from 'react'
import PropTypes from 'prop-types'
import MultiClamp from 'react-multi-clamp'

import * as S from './styled'

const MAX_SHORT_NAME_LENGTH = 61

const ProductInfo = ({ name, shortName, id, url }) => {
  const shouldShowEllipsis = name.substr(0, MAX_SHORT_NAME_LENGTH) === shortName && name.length > shortName.length

  return (
    <Fragment>
      <S.Title title={shortName} itemProp="url" href={url}>
        <MultiClamp
          ellipsis="..."
          clamp={3}
          itemProp="shortName"
        >
          {shouldShowEllipsis
            ? `${shortName}...`
            : shortName
          }
        </MultiClamp>
      </S.Title>
      <S.ProductRating>
        <S.ProductCode>Cód. {id}</S.ProductCode>
        <span
          className="product-rating bv-widget-rating"
          data-bv-show="inline_rating"
          data-bv-product-id={id}
          data-bv-redirect-url={url}
        />
      </S.ProductRating>
    </Fragment>
  )
}

ProductInfo.propTypes = {
  name: PropTypes.string.isRequired,
  shortName: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired
}

export default ProductInfo
